<template>
  <a-tabs default-active-key="1" @change="callback">
    <a-tab-pane key="1" tab="采购申请">
      <div class="content_main">
        <div class="content_main_top">
          <a-form @keyup.enter.native="handleSubmitSerch()">
            <a-input
              type="text"
              style="width: 260px"
              placeholder="请输入申请编号"
              allowClear
              v-model="purchaseCode"
              @keyup.enter.native="handleSubmitSerch"
            />
            <a-button type="primary" @click="handleSubmitSerch()" style="margin: 5px"> 搜索 </a-button>
            <a-button v-if="saveApply" type="primary" @click="add" style="margin: 5px"> 采购申请 </a-button>
            <a-button type="primary" @click="registration">采购预登记</a-button>
          </a-form>
        </div>
        <div class="content_main_center_scroll" id="content_main_center_scroll">
          <a-table
            :columns="columns"
            :data-source="data"
            bordered
            :pagination="pagination"
            :loading="loading"
            @change="handleTableChange"
            :scroll="{ y: scroll_y }"
          >
            <span slot="status" slot-scope="text" class="tag_class" :style="{ background: status_apply[text].color }">
              {{ statusMapConst[text] }}
            </span>
            <span slot="result" slot-scope="text" class="tag_class" :style="{ background: result_apply[text].color }">
              {{ resultMapConst[text] }}
            </span>
            <span slot="action" slot-scope="text, record">
              <a v-if="infoApply" @click="handelAudit(record)">详情</a>
              <a-divider type="vertical" />
              <a v-if="revokeApply" :disabled="record.status !== 1" @click="cancel([record.procInstId])">撤销</a>
              <!-- <a-divider type="vertical" />
								<a v-if="deleteApply" :disabled="record.status === 1" @click="delByIdsItem([record.id])">删除</a> -->
            </span>
          </a-table>
        </div>

        <a-modal
          title="资产申购-新增"
          :visible="visible"
          :closable="true"
          @cancel="handleCancel"
          :confirm-loading="confirmLoading"
          width="60%"
          :maskClosable="false"
        >
          <template slot="footer">
            <a-button key="back" @click="handleCancel"> 取消 </a-button>
            <a-button key="submit" type="primary" :loading="loading" @click="handleOkAdd"> 提交 </a-button>
          </template>
          <a-form-model ref="ruleForm" :rules="rules" :model="info" :label-col="labelCol" :wrapper-col="wrapperCol">
            <!-- <a-row>
								<a-col :span="12">
									<a-form-model-item label="选择抄送人部门">
										<a-cascader :options="options" placeholder="请选择" @change="onChangeDept" />
									</a-form-model-item>
								</a-col>
								<a-col :span="12">
									<a-form-model-item label="选择抄送人" prop="cc">
										<a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">
											全选
										</a-checkbox>
										<a-checkbox-group v-model="info.cc" :options="plainOptions" @change="onChangeFroup" />
									</a-form-model-item>
								</a-col>
							</a-row> -->
            <a-row>
              <a-form-model-item label="选择抄送人" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                <ccChange :data="ccC" @targetKeys="getdata" v-if="isRouterAlive" />
              </a-form-model-item>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item
                  label="费用归属部门"
                  prop="ascriptionDept"
                  :rules="{
                    required: true,
                    message: '请选择费用归属部门',
                    trigger: 'change',
                  }"
                >
                  <!-- <a-select allowClear placeholder="请选择" v-model="info.ascriptionDept" style="width: 364px;">
											<a-select-option :value="item.dept_id" v-for="(item, index) in deptlist" :key="index">
												{{ item.dept_name }}
											</a-select-option>
										</a-select> -->
                  <a-tree-select allowClear :treeData="deptTree" placeholder="请输入" v-model="info.ascriptionDept">
                  </a-tree-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item
                  label="采购类型"
                  prop="itemType"
                  :rules="{
                    required: true,
                    message: '请选择采购类型',
                    trigger: 'change',
                  }"
                >
                  <a-select allowClear placeholder="请选择" v-model="info.itemType" style="width: 364px">
                    <a-select-option :value="item.value" v-for="(item, index) in goodsType" :key="index">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item
                  label="期望交付日期"
                  prop="expectDate"
                  :rules="{
                    required: true,
                    message: '请选择期望交付日期',
                    trigger: 'change',
                  }"
                >
                  <a-date-picker
                    valueFormat="YYYY-MM-DD"
                    style="width: 364px"
                    :value="info.expectDate"
                    @change="timeChange"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="备注">
                   <a-input v-model="info.remark" placeholder="请输入"></a-input>
                  <!-- <a-input v-model="info.remark" placeholder="请输入"></a-input> -->
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
               <a-col :span="12">
                <a-form-model-item label="上传文件">
                   <uploadFileCode v-if="visible" ref="uploadFileCode" :data="billData" />
                  <!-- <a-input v-model="info.remark" placeholder="请输入"></a-input> -->
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-table :data-source="info.bizGoodsInfos" bordered :pagination="false">
                <a-table-column key="index" title="序号" data-index="index" width="70px">
                  <template scope="text, record, index">{{ index + 1 }}</template>
                </a-table-column>
                <a-table-column
                  key="goodsType"
                  title="* 登记编号"
                  class="note"
                  data-index="goodsType"
                  v-if="keynum == 2"
                >
                  <template slot-scope="text, record">
                    <a-input v-model="record.goodsType" placeholder="请输入"></a-input>
                  </template>
                </a-table-column>
                <a-table-column key="name" title="* 物品名称" class="note" data-index="name">
                  <template slot-scope="text, record">
                    <a-input v-model="record.name" placeholder="请输入"></a-input>
                  </template>
                </a-table-column>
                <a-table-column key="model" title="* 规格型号" class="note" data-index="model">
                  <template slot-scope="text, record">
                    <a-input v-model="record.model" placeholder="请输入"></a-input>
                  </template>
                </a-table-column>
                <a-table-column key="amount" title="* 数量" class="note" data-index="amount">
                  <template slot-scope="text, record">
                    <a-input v-model="record.amount" @blur="set_max_min(record)" placeholder="请输入"> </a-input>
                  </template>
                </a-table-column>
                <a-table-column key="unit" title="* 单位" class="note" data-index="unit">
                  <template slot-scope="text, record">
                    <a-input v-model="record.unit" placeholder="请输入"></a-input>
                  </template>
                </a-table-column>
                <a-table-column key="remark" title="备注" data-index="remark">
                  <template slot-scope="text, record">
                    <a-input v-model="record.remark" placeholder="请输入"></a-input>
                  </template>
                </a-table-column>
                <a-table-column key="usages" title="* 使用部门" class="note" data-index="usages" width="300px">
                  <template slot-scope="text, record">
                    <!-- <a-select allowClear placeholder="请选择" v-model="record.usages">
												<a-select-option :value="item.dept_id" v-for="(item, index) in deptlist" :key="index">
													{{ item.dept_name }}
												</a-select-option>
											</a-select> -->
                    <a-tree-select
                      allowClear
                      multiple
                      :treeData="deptTree"
                      placeholder="请输入"
                      v-model="record.usages"
                      treeDefaultExpandAll
                    >
                    </a-tree-select>
                  </template>
                </a-table-column>
                <a-table-column key="action" title="操作" data-index="action" width="70px">
                  <template scope="text,record,index">
                    <a @click="removei(index)">删除</a>
                  </template>
                </a-table-column>
              </a-table>
            </a-row>
            <a-row>
              <div class="btn_last">
                <a-button type="primary" @click="add_detail"> <a-icon type="plus" />添加 </a-button>
              </div>
            </a-row>
          </a-form-model>
        </a-modal>
        <a-modal v-model="is_registration" title="资产申购-采购预登记" width="70%" :maskClosable="false">
          <template slot="footer">
            <a-button key="back" @click="is_registration = false"> 取消 </a-button>
            <a-button key="submit" type="primary" @click="registration_delivery"> 提交 </a-button>
          </template>
          <a-form-model
            :rules="apply_rules"
            ref="apply_ref2"
            :model="apply_pre"
            :label-col="labelCol3"
            :wrapper-col="wrapperCol3"
          >
            <a-row>
              <a-table :data-source="apply_pre.old_goods" bordered :pagination="false">
                <a-table-column key="goodsType" title="登记编号" data-index="goodsType" width="200px">
                  <template scope="text,record">
                    <a-input v-model="record.goodsType" placeholder="请输入登记编号" />
                  </template>
                </a-table-column>
                <a-table-column key="name" title="物品名称" data-index="name" width="200px">
                  <template scope="text,record">
                    <a-input v-model="record.name" placeholder="请输入物品名称" />
                  </template>
                </a-table-column>
                <a-table-column key="model" title="规格型号" ellipsis="true" data-index="model">
                  <template scope="text,record">
                    <a-input v-model="record.model" placeholder="请输入规格型号" />
                  </template>
                </a-table-column>
                <a-table-column key="amount" title="数量" ellipsis="true" data-index="amount">
                  <template scope="text,record">
                    <a-input v-model="record.amount" type="number" placeholder="请输入数量" />
                  </template>
                </a-table-column>
                <a-table-column key="unit" title="单位" ellipsis="true" data-index="unit">
                  <template scope="text,record">
                    <a-input v-model="record.unit" placeholder="请输入单位" />
                  </template>
                </a-table-column>
                <a-table-column key="remark" title="备注" ellipsis="true" data-index="remark">
                  <template scope="text,record">
                    <a-input v-model="record.remark" placeholder="请输入备注" />
                  </template>
                </a-table-column>
                <a-table-column key="usages" title="使用部门" data-index="usages" width="200px">
                  <template scope="text,record">
                    <a-select allowClear placeholder="请选择" v-model="record.usages">
                      <a-select-option :value="item.deptId" v-for="(item, index) in deptlist" :key="index">
                        {{ item.title }}
                      </a-select-option>
                    </a-select>
                  </template>
                </a-table-column>
                <a-table-column key="action" title="操作" data-index="action">
                  <template scope="text,record,index">
                    <a @click="deletes(index)">删除</a>
                  </template>
                </a-table-column>
              </a-table>
            </a-row>
            <a-row>
              <div class="btn_last">
                <a-button type="primary" @click="add_detailregi"> <a-icon type="plus" />添加 </a-button>
              </div>
            </a-row>
          </a-form-model>
        </a-modal>
        <!-- 撤销提示 -->
        <a-modal v-model="is_revocation" title="确认撤销此申请吗?" on-ok="handleOkReason">
          <template slot="footer">
            <a-button key="back" @click="is_revocation = false"> 取消 </a-button>
            <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason"> 撤销 </a-button>
          </template>
          <a-textarea placeholder="请输入原因" v-model="reason" />
        </a-modal>
        <!-- 详情 -->
        <purchase-modal ref="purchasemodal" :audit="false" />
      </div>
    </a-tab-pane>
    <a-tab-pane key="2" tab="登记记录">
      <div class="content_main">
        <div class="content_main_top">
          <a-button type="primary" style="margin-right: 5px" @click="add" :disabled="selectedRowKeysTabItems.length < 1"
            >申购</a-button
          >
        </div>
        <div class="content_main_top">
          <a-input
            placeholder="物品名称"
            allowClear
            v-model="query.name"
            class="a_input_self margin_self"
            @keyup.enter.native="serch2"
          />
          <a-input
            placeholder="登记编号"
            allowClear
            v-model="query.spu_sn"
            class="a_input_self margin_self"
            @keyup.enter.native="serch2"
          />
          <!-- <a-range-picker valueFormat="YYYY-MM-DD" allowClear v-model="date" :placeholder="['采购开始', '采购结束']" /> -->
          <a-button type="primary" style="margin: 5px" @click="serch2"> 查询 </a-button>
          <a-button type="primary" ghost @click="result2"> 重置 </a-button>
        </div>
        <div class="content_main_center_scroll" id="content_main_center_scroll">
          <a-table
            :data-source="data2"
            bordered
            :scroll="{ y: scroll_y }"
            rowKey="id"
            :row-selection="{ selectedRowKeys: selectedRowKeysTab, onChange: onSelectChangeTab }"
            :pagination="pagination2"
            @change="handleTableChange2"
          >
            <a-table-column key="index" title="序号" data-index="index" width="70px">
              <template scope="text, record, index">{{
                (pagination2.current - 1) * pagination2.pageSize + index + 1
              }}</template>
            </a-table-column>
            <a-table-column key="goodsType" ellipsis="true" title="登记编号" data-index="goodsType" />
            <a-table-column key="name" ellipsis="true" title="物品名称" data-index="name" />
            <a-table-column key="model" ellipsis="true" title="规格型号" data-index="model" />
            <a-table-column key="amount" ellipsis="true" title="数量" data-index="amount" />
            <a-table-column key="unit" ellipsis="true" title="单位" data-index="unit" />
            <a-table-column key="remark" ellipsis="true" title="备注" data-index="remark" />
            <a-table-column key="createTime" ellipsis="true" title="录入时间" data-index="createTime" />
            <a-table-column key="action" title="操作" data-index="action" width="100">
              <template scope="text,record">
                <a @click="goods_update(record)">编辑</a>
                <a-divider type="vertical" />
                <a @click="goods_delete(record)">删除</a>
              </template>
            </a-table-column>
          </a-table>
        </div>
      </div>
      <a-modal
        title="登记记录-编辑"
        :visible="goods_update_visible"
        @ok="editOk"
        @cancel="goods_update_visible = false"
        width="880px"
        :maskClosable="false"
      >
        <template slot="footer">
          <a-button key="back" @click="goods_update_visible = false"> 取消 </a-button>
          <a-button type="primary" @click="editOk"> 保存 </a-button>
        </template>
        <a-form-model ref="ruleForm" :rules="rules" :model="updaterow" :labelCol="labelCol4" :wrapperCol="wrapperCol4">
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="登记编号">
                <a-input allowClear v-model="updaterow.goodsType" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="物品名称">
                <a-input allowClear v-model="updaterow.name" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="规格型号">
                <a-input allowClear v-model="updaterow.model" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="数量">
                <a-input allowClear v-model="updaterow.amount" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="单位">
                <a-input allowClear v-model="updaterow.unit" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="备注">
                <a-input allowClear v-model="updaterow.remark" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="使用部门">
                <a-select allowClear placeholder="请选择" v-model="updaterow.usages">
                  <a-select-option :value="item.deptId" v-for="(item, index) in deptlist" :key="index">
                    {{ item.title }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-modal>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import uploadFileCode from '@/components/module/uploadFileCode.vue'
import { getDeptListEnable2 } from '@/api/system'
import debounce from 'lodash/debounce'
import { statusMap, resultMap, delProcessIns, delBusiness, modalMap, purchaseCode } from '@/api/activiti'
import { dict } from '@/api/assetmenag'
import {
  get_my_lis,
  remove_my_item,
  purchase_save,
  purchase_apply_get,
  selectGoodsListFixed,
  anticipate_goods,
  anticipate_goods_listall,
  anticipate_goods_update,
  anticipate_goods_delete,
  tree_all,
} from '@/api/purchase'
import { returnDept2, get_users, get_dict } from '@/utils/unit_axios'
import { checkPermission } from '@/utils/permissions'
import PurchaseModal from '../activiti/modules/PurchaseModal.vue'
import ccChange from '@/components/module/ccChange'
const columns = [
  {
    title: '申请时间',
    dataIndex: 'createTime',
  },
  {
    title: '申请编号',
    dataIndex: 'purchaseCode',
  },
  {
    title: '申请人',
    dataIndex: 'createByName',
  },
  {
    title: '标题',
    dataIndex: 'title',
  },
  {
    title: '审批结果',
    dataIndex: 'result',
    scopedSlots: {
      customRender: 'result',
    },
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: {
      customRender: 'status',
    },
  },
  {
    title: '操作',
    width: '170px',
    dataIndex: 'action',
    scopedSlots: {
      customRender: 'action',
    },
  },
]

export default {
  data() {
    return {
      time: null,
      purchaseData: '',
       billData: {
                code: '',
                type: 'purchase-certificate',
            },
      deptTree: [],
      is_registration: false,
      purchaseCode: '',
      scroll_y: 150,
      isRouterAlive: true,
      selectedRowKeysTab: [],
      selectedRowKeysTabItems: [],
      assettype: [],
      operTypeMap: {},
      statusMapConst: statusMap,
      resultMapConst: resultMap,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showLessItems: true,
        showSizeChanger: true,
      },
      companylist: [],
      deptlist: [],
      searchValue: '', //搜索关键字
      is_revocation: false, //撤销
      ids: '', //撤销id
      reason: '', //撤销原因
      loading: false,
      form: this.$form.createForm(this, {
        name: 'coordinated',
      }),
      data: [],
      selectedRowKeys: [],
      columns,
      visible: false,
      confirmLoading: false,
      applyList: {
        name: '',
        model: '',
        amount: '',
      },
      query: {
        spu_sn: '',
        name: '',
      },
      info: {
        cc: [], //抄送人
        expectDate: '',
        ascriptionDept: undefined,
        itemType: undefined,
        remark: '',
        bizGoodsInfos: [
          {
            expectDate: '',
            itemType: '',
            name: '', //物品名称
            model: '', //规格型号
            amount: '', //数量
            unit: '', //单位
            remark: '', //备注
            usages: undefined, //采购物品实际使用
          },
        ],
      },
      rules: {
        deptId: [
          {
            required: true,
            message: '请选择部门',
            trigger: 'blur',
          },
        ],
      },
      labelCol2: {
        span: 2,
      },
      wrapperCol2: {
        span: 22,
      },
      options: [], //部门
      labelCol: {
        span: 8,
      },
      wrapperCol: {
        span: 16,
      },
      labelCol4: {
        span: 6,
      },
      wrapperCol4: {
        span: 18,
      },
      keynum: '',
      indeterminate: false,
      checkAll: false,
      plainOptions: [], //全项
      details: null,
      is_details: false,
      ccC: 'purchase',
      data2: '',
      apply_pre: {
        old_goods: [],
      },
      updaterow: '',
      goods_update_visible: false,
      pagination2: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showLessItems: true,
        showSizeChanger: true,
      },
      saveApply: checkPermission('administrative:apply:save'),
      infoApply: checkPermission('administrative:apply:info'),
      revokeApply: checkPermission('administrative:apply:revoke'),
      deleteApply: checkPermission('administrative:apply:delete'),
    }
  },
  components: {
    PurchaseModal,
    ccChange,
    uploadFileCode
  },
  created() {
    this.get_lis()
    this.get_list2()
    returnDept2((res) => {
      this.options = res.depts
      console.log(res.depts, 12)
    })
    tree_all().then((res) => {
      if (res.code == 200) {
        this.companylist = res.data[0]
        this.companylist.unshift({
          deptId: 0,
          deptName: '所有公司',
          children: [],
        })
      }
      console.log(this.companylist, 'companylist===================')
    })
    dict({
      pageNum: 1,
      pageSize: 10,
      dictType: 'assets_type',
    }).then((res) => {
      this.assettype = res.rows
      this.assettype.map((d) => {
        this.operTypeMap[d.dictCode] = {
          text: d.dictLabel,
        }
      })
    })
    getDeptListEnable2().then((res) => {
      const data = res.rows
      console.log(res.rows, 'res.rowsres.rowsres.rowsres.rows==================================')
      if (data.length > 0) {
        const min = Math.min(...data.map((m) => m.parentId))
        this.buildtree2(data, this.deptTree, this.$store.getters.userInfo.companyId)
      }
    })
  },
  mounted() {
    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height() - 120
      }, 1000)
    })
  },
  methods: {
    buildtree2(list, arr, parentId) {
      list.forEach((item) => {
        if (item.parentId === parentId) {
          var child = {
            key: item.deptId,
            value: item.deptId, // value是给modal的select用的，2者属性不一样
            title: item.deptName,
            scopedSlots: {
              title: 'title',
            },
            children: [],
          }
          this.buildtree2(list, child.children, item.deptId)
          if (child.children.length === 0) {
            delete child.children
          }
          arr.push(child)
        }
      })
    },
    deletes(idx) {
      this.apply_pre.old_goods.splice(idx, 1)
    },
    callback(key) {
      this.keynum = key
      this.selectedRowKeysTab = []
      this.selectedRowKeysTabItems = []
      if (key == 1) {
        this.get_lis()
      } else if (key == 2) {
        this.get_list2()
      }
    },
    editOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          anticipate_goods_update(this.updaterow)
            .then((res) => {
              if (res.code == 200) {
                this.goods_update_visible = false
                this.$message.success('编辑成功')
                this.get_list2()
              } else {
                this.$message.success(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
        } else {
          return false
        }
      })
    },
    goods_update(row) {
      this.companylist.forEach((item) => {
        if (item.deptId == this.$store.getters.userInfo.companyId) {
          this.deptlist = item.children
        }
        console.log(this.deptlist, 'deptlist=================================')
      })
      this.goods_update_visible = true
      var rows = row
      let resData = {}
      for (let key in rows) {
        resData[key] = rows[key]
      }
      this.updaterow = resData
    },
    goods_delete(row) {
      anticipate_goods_delete([row.id]).then((res) => {
        if (res.code != 200) {
          this.$message.error(res.msg)
          return
        }
        this.$message.success('删除成功')
        this.get_list2()
      })
    },
    serch2() {
      this.loading = true
      this.pagination2.current = 1
      this.get_list2()
    },
    result2() {
      this.query.spu_sn = ''
      this.query.name = ''
    },
    //选择第一个表格
    onSelectChangeTab(selectedRowKeys, selectedRows) {
      var arr = JSON.parse(JSON.stringify(selectedRows))
      this.selectedRowKeysTabItems = this.selectedRowKeysTabItems.concat(arr)
      this.selectedRowKeysTab = selectedRowKeys
      var obj = {}
      this.selectedRowKeysTabItems = this.selectedRowKeysTabItems.reduce(function (item, next) {
        obj[next.id] ? '' : (obj[next.id] = true && item.push(next))
        return item
      }, [])
      var newLis = []
      this.selectedRowKeysTab.forEach((key, idx) => {
        this.selectedRowKeysTabItems.forEach((item, index) => {
          if (key == item.id) {
            newLis.push(item)
          }
        })
      })
      this.selectedRowKeysTabItems = newLis
    },
    handleTableChange2(pagination, filters, sorter) {
      this.pagination2.current = pagination.current
      this.pagination2.pageSize = pagination.pageSize
      this.get_list2()
    },
    get_list2() {
      this.loading = true
      anticipate_goods_listall({
        page_size: this.pagination2.pageSize,
        page_num: this.pagination2.current,
        assetType: 0,
        name: this.query.name,
        goodsType: this.query.spu_sn,
      }).then((res) => {
        this.loading = false
        const pagination = {
          ...this.pagination2,
        }
        pagination.total = res.total
        this.pagination2 = pagination
        this.data2 = res.rows
      })
    },
    registration_delivery: debounce(
      function () {
        var _this = this
        this.$refs.apply_ref2.validate((valid) => {
          if (valid) {
            var bizAnticipateGoods = []
            _this.apply_pre.old_goods.forEach((item) => {
              bizAnticipateGoods.push({
                name: item.name,
                model: item.model,
                amount: item.amount,
                unit: item.unit,
                goodsType: item.goodsType,
                remark: item.remark,
                usages: item.usages,
                assetType: 0,
              })
            })
            anticipate_goods(bizAnticipateGoods).then((res) => {
              if (res.code != 200) {
                this.$message.error(res.msg)
                return
              }
              this.$message.success('采购预登记成功')
              this.get_lis()
              this.is_registration = false
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      1000,
      {
        leading: true,
        trailing: false,
      }
    ),
    add_detailregi() {
      this.apply_pre.old_goods.push({})
    },
    registration() {
      this.apply_pre = {
        old_goods: [{}],
      }
      this.companylist.forEach((item) => {
        if (item.deptId == this.$store.getters.userInfo.companyId) {
          this.deptlist = item.children
        }
      })
      this.is_registration = true
    },
    //限制最大值
    set_max_min(row) {
      if (row.amount < 1) {
        row.amount = 1
      }
      this.$forceUpdate()
    },
    timeChange(date) {
      this.info.expectDate = date
    },
    removei(index) {
      console.log(index)
      this.info.bizGoodsInfos.splice(index, 1)
    },
    add_detail() {
      this.info.bizGoodsInfos.push({
        expectDate: '',
        itemType: '',
        name: '', //物品名称
        model: '', //规格型号
        amount: '', //数量
        unit: '', //单位
        remark: '', //备注
        usages: undefined, //采购物品实际使用
      })
    },
    getdata(data) {
      this.info.cc = data
    },
    unitnotnumber(item) {
      item.unit = item.unit.replace(/[^\u4E00-\u9FA5]/g, '')
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().endOf('day')
    },
    //搜索
    handleSubmitSerch() {
      this.loading = true
      this.pagination.current = 1
      this.get_lis()
    },
    //获取列表
    get_lis() {
      selectGoodsListFixed({
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        purchaseCode: this.purchaseCode,
        // procDefKey: 'purchase',
        // searchValue: this.searchValue,
      }).then((res) => {
        this.data = res.rows
        this.loading = false
        const pagination = {
          ...this.pagination,
        }
        pagination.total = res.total
        this.pagination = pagination
      })
    },
    //改变分页
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loading = true
      this.get_lis()
    },
    // 撤销
    cancel(ids) {
      this.is_revocation = true
      this.ids = ids
      this.reason = ''
    },
    //撤销提交
    handleOkReason() {
      delProcessIns({
        ids: this.ids.join(','),
        reason: this.reason,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success('撤销成功')
          this.get_lis()
          this.is_revocation = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    //删除
    delByIdsItem(ids) {
      var _this = this
      this.$confirm({
        title: '确认删除此申请?',
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          remove_my_item({
            ids: ids.join(','),
          }).then((res) => {
            if (res.code === 0) {
              _this.$message.success('删除成功')
              _this.get_lis()
            } else {
              _this.$message.error(res.msg)
            }
          })
        },
        onCancel() {},
        class: 'test',
      })
    },
    //关闭申请弹框
    handleCancel(e) {
      this.$refs.ruleForm.clearValidate()
      this.$refs.ruleForm.resetFields()
      this.visible = false
    },
    //选择部门
    onChangeDept(value) {
      this.info.cc = []
      this.checkAll = false
      this.info.deptKey = value[1]
      get_users(value[1], (res) => {
        res.forEach((item) => {
          item['label'] = item.userName
          item['value'] = item.userId
        })
        console.log(this.info.deptKey)
        this.plainOptions = res
      })
    },
    // 某项改变
    onChangeFroup(checkedList) {
      this.indeterminate = !!checkedList.length && checkedList.length < this.plainOptions.length
      this.checkAll = checkedList.length === this.plainOptions.length
    },
    //全选改变
    onCheckAllChange(e) {
      var vs = []
      this.plainOptions.forEach((item) => {
        vs.push(item.value)
      })
      this.info.cc = e.target.checked ? vs : []
      this.indeterminate = false
      this.checkAll = e.target.checked
    },
    //点击新增按钮
    add() {
      //获取code
      purchaseCode().then(res => {
        if(res.code == 200) {
          this.billData.code = res.data
          this.purchaseData = res.data
        } else {
          this.$message.error(res.msg)
        }

      })
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
      this.companylist.forEach((item) => {
        if (item.deptId == this.$store.getters.userInfo.companyId) {
          this.deptlist = item.children
        }
      })
      this.info = {
        cc: [], //抄送人
        expectDate: '',
        ascriptionDept: undefined,
        itemType: undefined,
        remark: '',
        bizGoodsInfos: [
          {
            expectDate: '',
            itemType: '',
            goodsType: '',
            name: '', //物品名称
            model: '', //规格型号
            amount: '', //数量
            unit: '', //单位
            remark: '', //备注
            usages: undefined, //采购物品实际使用
          },
        ],
      }
      if (this.keynum == 2) {
        this.info.bizGoodsInfos = this.selectedRowKeysTabItems
      }
      this.visible = true
    },
    //新增物品
    addGood() {
      this.info.bizGoodsInfos.push({
        itemType: undefined, //物品类型
        usages: '', //用途
        name: '', //物品名称
        model: '', //规格型号
        amount: '', //数量
        unit: '', //单位
        remark: '', //备注
        expectDate: '', //期望交付日期
      })
    },
    //删除一个物品
    delGood(idx) {
      this.info.bizGoodsInfos.splice(idx, 1)
    },
    //提交
    handleOkAdd: debounce(
      function () {
        var _this = this
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            _this.$store.commit('LOADING', true)
            _this.$store.commit('TIPS', '提交中......')
            var is = true
            var lis = _this.info.bizGoodsInfos
            lis.forEach((item) => {
              item['expectDate'] = _this.info.expectDate
              item['itemType'] = _this.info.itemType
              item['ascriptionDept'] = _this.info.ascriptionDept
              if (item['usages'] instanceof Array) {
                item['usages'] = item['usages'].join(',')
              }
              // item['usages'] = item['usages'].join(',')
            })
            console.log(lis)
            if (this.keynum == 2) {
              lis.forEach((item) => {
                item['anticipateGoodsId'] = item['id']
                delete item['id']
              })
            }
            
             console.log(this.time, 'time=======================')
              if(this.time !== null){
                clearTimeout(this.time);
            }
             this.time = setTimeout(() => {
                purchase_save({
              purchaseCode: this.purchaseData,
              cc: _this.info.cc.length ? this.info.cc.join(',') : '',
              bizGoodsInfos: lis,
              remark: _this.info.remark,
            }).then((res) => {
              _this.$store.commit('LOADING', false)
              _this.$store.commit('TIPS', '加载中......')
              console.log(res)
              if (res.code != 200) {
                this.$refs.ruleForm.clearValidate()
                this.$refs.ruleForm.resetFields()
                this.$message.error(res.msg)
                this.isRouterAlive = false
                this.$nextTick(() => {
                  this.isRouterAlive = true
                })
                return
              }
              this.get_lis()
              this.get_list2()
              this.$message.success('新增成功！')
              this.visible = false
            })
               
            },500)
          
           
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      1000,
      {
        leading: true,
        trailing: false,
      }
    ),
    // 详情
    handelAudit(record) {
      this.$refs.purchasemodal.show({
        businessKey: record.id,
        procInstId: record.procInstId,
        procDefKey: 'purchase',
      })
    },
    //数量失去焦点
    blurAmount(row) {
      if (row.amount < 1) {
        row.amount = 1
      }
    },
  },
}
</script>

<style>
.dialog {
  display: flex;
  justify-content: space-between;
}

.dialog .dialog_item {
  margin-bottom: 5px;
  line-height: 32px;
  display: flex;
  justify-content: space-between;
}

.btn_last {
  width: 100%;
  float: left;
  display: flex;
  margin-top: 10px;
  justify-content: flex-start;
  align-items: flex-end;
}

.note {
  color: #f5222d !important;
}
</style>
